export const WIXTAR_EXHAUSTED_WARNING = '目前已發完，發送時會失敗';
export const COUPON_EXHAUSTED_WARNING = '已達總發行上限，發送時會失敗';

export function isWixtarTicketExhausted(ticket) {
  if (!ticket) return false;
  if (ticket.status === 'sold_out') return true;
  if (ticket.availableQuantity == null || ticket.availableQuantity === '') return false;
  return Number(ticket.availableQuantity) <= 0;
}

export function isCouponTemplateExhausted(template) {
  if (!template || template.totalIssueLimit == null || template.totalIssueLimit === '') return false;
  return Number(template.totalIssued || 0) >= Number(template.totalIssueLimit);
}
